import { html } from 'lit';
const AlignRight =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M19 3.25a.75.75 0 0 1 .75.75v16a.75.75 0 0 1-1.5 0v-4.031A1 1 0 0 1 18 16h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 .25.031V10.97A1 1 0 0 1 18 11H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h12q.13 0 .25.031V4a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
export default AlignRight;
